import { useSearchParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { Nice } from "@/components/Nice";

const Acorn = ({ gold, n }) => (
  <svg viewBox="0 0 54 64" aria-label={`${gold ? "golden " : ""}acorn ${n}`}>
    <path d="M8 22 C8 10 46 10 46 22 C46 26 8 26 8 22 Z" fill="none" stroke={gold ? "#d0951c" : "#1d1a2f"} strokeWidth="2.5" />
    <path d="M27 10 L29 3" stroke={gold ? "#d0951c" : "#1d1a2f"} strokeWidth="2.5" strokeLinecap="round" />
    <path d="M11 25 C11 44 22 58 27 60 C32 58 43 44 43 25" fill="none" stroke={gold ? "#d0951c" : "#1d1a2f"} strokeWidth="2.5"
      strokeDasharray={gold ? "4 3" : "0"} />
    <text x="27" y="44" textAnchor="middle" fontSize="11" fill={gold ? "#d0951c" : "#8a8478"}>{n}</text>
  </svg>
);

const Grid = ({ count, gold, testId }) => (
  <div className={`pp-chart-grid ${gold ? "gold" : ""}`} data-testid={testId}>
    {Array.from({ length: count }, (_, i) => <Acorn key={i} gold={gold} n={i + 1} />)}
  </div>
);

export default function PrintRewardChart() {
  const [p] = useSearchParams();
  const reward = p.get("reward");
  const name = p.get("name");
  const acorns = reward ? Math.min(Number(p.get("acorns")) || 0, 100) : 30;
  const golden = reward ? Math.min(Number(p.get("golden")) || 0, 20) : 0;

  return (
    <div className="pp-dcards" data-testid="print-reward-chart-page">
      <div className="pp-dcards-bar no-print">
        <p>Print it, stick it on the fridge, and color in one acorn each time you earn one!</p>
        <button className="pp-primary" onClick={() => window.print()} data-testid="print-chart-button"><Printer className="h-5 w-5" /> Print</button>
      </div>
      <article className="pp-chart-sheet" data-testid="reward-chart">
        <img src="/acorn-t.png" alt="" style={{ width: 64, margin: "0 auto" }} />
        <h1>{name ? `${name}'s` : "My"} Acorn Chart</h1>
        <p className="mt-3 text-lg">I'm working toward: {reward
          ? <b className="pp-chart-line" data-testid="chart-reward">{reward}</b>
          : <span className="pp-chart-line" data-testid="chart-reward-blank">&nbsp;</span>}</p>
        <Grid count={acorns} testId="chart-acorns" />
        {golden > 0 && (
          <>
            <p className="mt-6 font-bold" style={{ color: "#a16207" }}>Plus {golden} golden acorn{golden > 1 ? "s" : ""} for gratitude & great manners</p>
            <Grid count={golden} gold testId="chart-golden" />
          </>
        )}
        <p className="mt-6 text-sm">When it's all colored in, show your grown-up!</p>
        <footer><Nice />™ · A Colorful Acorn Parenting™ Resource · BurrHaus Counseling</footer>
      </article>
    </div>
  );
}
